export default "__VITE_ASSET__Bm8VfeWQ__"